// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"220baad0","957":"34964fa5"}[chunkId] + ".chunk.js";
};